// Service selector component for filtering tasks by service
// Created for service filtering in TeamView
// UPDATED: Refactored to use BaseFilterDropdown for consistency
// UPDATED: Added "Clear All" button in header (visible when items selected)
// Supports selecting multiple services simultaneously for flexible task filtering
// Displays service color badges for visual recognition (preserved for differentiation)

import { Tag } from 'lucide-react';
import { BaseFilterDropdown } from '../ui/BaseFilterDropdown';
import type { Service } from '../../lib/services';
import { getServiceColorClass } from '../../lib/services';

interface ServiceSelectorProps {
  services: Service[];
  selectedServiceIds: string[];
  onServiceChange: (serviceIds: string[]) => void;
  compact?: boolean;
}

export function ServiceSelector({
  services,
  selectedServiceIds,
  onServiceChange,
  compact = false
}: ServiceSelectorProps) {
  return (
    <BaseFilterDropdown
      items={services}
      selectedItems={selectedServiceIds}
      onSelectionChange={onServiceChange}
      getItemId={(service) => service.id}
      getItemLabel={(service) => service.name}
      label="Services"
      icon={compact ? <Tag size={16} /> : undefined}
      placeholder="Aucun service"
      emptyMessage="Aucun service disponible"
      singleSelection={false}
      compact={compact}
      searchable={false}
      showSelectAll={true}
      showFooter={false}
      renderOption={(service) => (
        <span
          className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold border ${getServiceColorClass(service.color)}`}
        >
          {service.name}
        </span>
      )}
    />
  );
}
